// extracted by mini-css-extract-plugin
export var textInput = "_kq-0";